













































































































import {defineComponent, reactive, ref, watch} from '@vue/composition-api'
import useRootSetting from '@/hooks/useRootSetting';
import request from '@/utils/request'
import {getToday} from '@/utils'
export default defineComponent({
  components: {},
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    formData: {
      type: Object,
      default: () => {
      }
    },
    submitLoading: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const {getIsMobile} = useRootSetting()
    const formRef = ref(null)
    const  taxRate = ref(13)
      const rules = {
      xhname: [
        { required: true, message: '型号不能为空', trigger: 'blur' }
      ],
      source: [
        { required: true, message: '品牌不能为空', trigger: 'blur' }
      ],
      // address: [
      //   { required: true, message: '产地不能为空', trigger: 'blur' }
      // ],
      // baozhuang: [
      //   { required: true, message: '包装不能为空', trigger: 'blur' }
      // ],
      number: [
        { required: true, message: '库存数量不能为空', trigger: 'blur' },
        { type: 'number', message: '库存数量必须为数字值'}
      ],
      // beizhu: [
      //   { required: true, message: '备注不能为空', trigger: 'blur' }
      // ],
      gongyingshang: [
        { required: true, message: '供应商不能为空', trigger: 'blur' }
      ],
      wshui: [
        { required: true, message: '未税价格不能为空', trigger: 'blur' },
      ],
      // hshui: [
      //   { required: true, message: '含税价格不能为空', trigger: 'blur' },
      // ],
      // kufang: [
      //   { required: true, message: '库房货位不能为空', trigger: 'blur' }
      // ],
      // zdyprice: [
      //   { required: true, message: '自定义价格不能为空', trigger: 'blur' },
      // ],
      // spfph: [
      //   { required: true, message: '收票发票号不能为空', trigger: 'blur' }
      // ],
      settime: [
        { required: true, message: '进货日期不能为空', trigger: 'change' }
      ],
      // spzt: [
      //   { required: true, message: '收票状态不能为空', trigger: 'blur' }
      // ],
      title: [
        { required: true, message: '商品名称不能为空', trigger: 'blur' }
      ],
      // zt: [
      //   { required: true, message: '合同状态不能为空', trigger: 'change' }
      // ]
    }

    const defaultForm = (): Record<string, string | number> => ({
      xhname: '',
      source: '',
      address: '',
      baozhuang: '',
      number: '',
      beizhu: '',
      gongyingshang: '',
      wshui: '',
      hshui: '',
      kufang: '',
      zdyprice: '',
      spfph: '',
      settime: getToday(),
      spzt: 1,
      title: '轴承',
      zt: 1
    })
    const form = reactive<Record<string, string | number>>(defaultForm())

    watch(()=> props.formData, (val)=> {
      if (!val || typeof val !== 'object') return;
      Object.keys(val).forEach((key) => {
        if (key in form) {
          const value = val[key];
          // 判断 value 是否为字符串形式的纯数字
          if (typeof value === 'string' && value !== '' && !isNaN(Number(value))) {
            form[key] = Number(value);
          } else {
            form[key] = value;
          }
        }
      });
    },{deep:true})

    const handleReset = () => {
      Object.assign(form, defaultForm())
    }

    const handleSubmit = () => {
      formRef.value.validate(valid => {
        if (valid) {
          emit('submit', form)
        }
      })
    }
    const handleClose = () => {
      Object.assign(form, defaultForm())
      emit('close')
    }

    const category = ref([])
    const getCategory = () => {
      request({
        url: 'shop_type_list.yy',
        method: 'post',
      }).then((res) => {
        const {code, data} = res
        if(code == 200) category.value = data
      })
    }

    const options = ref([])
    const loading = ref(false)
    //远程搜索型号方法
    const remoteMethod = async (query) => {
      if (!query) {
        options.value = []
        return
      }
      loading.value = true
      try {
        const { data } = await request({
          url: 'inventory_supplier.yy',
          method: 'get',
          params: { gongyingshang: query }
        })

        options.value = data.map(item => ({
          label: item,
          value: item
        }))
      } catch (error) {
        console.error('搜索失败', error)
      } finally {
        loading.value = false
      }
    }

    //模糊下拉供应商选中请求接口
    const handleChange = (name) => {
      form.gongyingshang = name
    }

    watch(()=>props.dialog,(val)=>{
      if(val){
        getCategory()
      }
    })

    const activeShuiFiled = ref('')
    // 监听未税和含税价格，分清当前编辑的是哪个字段
    watch(
      [() => form.wshui, () => form.hshui, () => taxRate.value],
      ([newWshui, newHshui, newTaxRate]) => {
        if (!newTaxRate) {
          form.hshui = '0';
          form.wshui = '0';
          return;
        }

        if (activeShuiFiled.value === 'wshui') {
          if (newWshui) {
            form.hshui = (Number(newWshui) * (1 + newTaxRate / 100)).toFixed(2);
          } else {
            form.hshui = '0';
          }
        } else if (activeShuiFiled.value === 'hshui') {
          if (newHshui) {
            form.wshui = (Number(newHshui) / (1 + newTaxRate / 100)).toFixed(2);
          } else {
            form.wshui = '0';
          }
        }
      }
    );

    return {
      activeShuiFiled,
      taxRate,
      loading,
      options,
      category,
      getIsMobile,
      formRef,
      form,
      rules,
      handleChange,
      remoteMethod,
      getCategory,
      handleReset,
      handleSubmit,
      handleClose
    }
  }
})
